import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import { api_domain } from "../config"
import { CroppedScreenshot } from "../components/croppedImage.tsx";
import Menu from "../components/navbar.js";
import { AuthContext } from "../components/AuthContext";
// search result - no text description, optional fields (extra_metadata)
// all ad displays - no relational ids

function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function Ad() {
  let params = useParams();
  let blur = useQuery().get("blur");
  if (!blur) {
     blur = "true";
  }

  const [ad, setAd] = useState(null);
  const { basicHttpAuthString } = useContext(AuthContext);

  useEffect(() => {
    fetch(`${api_domain}/ad/${params.adId}`, {
      headers: {
        Authorization: `${basicHttpAuthString}`
      }
    })
      .then((response) => response.json())
      .then((data) => setAd(data));
  }, [params.adId]);

  return (<div className="container">
    <Menu/> 
    <div className="tools">
      {ad && (
        <div>
          <div className="titleMain">ad: {ad.id}</div>
          {ad.batch_id && (
            <div className="titleMinor">
              <b>batch id:</b> {ad.batch_id}
            </div>
          )}
          {ad.capture_timestamp && (
            <div className="titleMinor">
              <b>capture date:</b> {new Date(ad.capture_timestamp).toString()}
            </div>
          )}
          {ad.parent_url && (
            <div className="titleMinor">
              <b>parent url:</b> <a href={ad.parent_url}>{ad.parent_url}</a>
            </div>
          )}
          {ad.landing_url && (
            <div className="titleMinor">
              <b>landing url:</b> <a href={ad.landing_url}>{ad.landing_url}</a>
            </div>
          )}
          {/* TODO: labels */}
          {/* {ad.labels && <p>landing url: {ad.labels}</p>} */}
          {ad.text_description && (
            <div className="titleMinor">
              <b>description:</b> {ad.text_description}
            </div>
          )}
          {ad.extra_metadata && (
            <div className="titleMinor">
              <b>extra metadata:</b> <pre><code>{JSON.stringify(ad.extra_metadata, null, 4)}</code></pre>
            </div>
          )}
          <CroppedScreenshot ad={ad} blur={blur} url={`${api_domain}/i/${ad.path_to_image}`}/>
          <div>
            <br />
            <div className="titleMainTwo">Batch: <a href={`/batch/${ad.batch_id}`}>
              {ad.batch_id}
            </a></div>
            {ad.batch.human_name && (
              <div className="titleMinor">
                <b>human name:</b> {ad.batch.human_name}
              </div>
            )}
            {/* TODO: specific format?*/}
            {ad.batch.batch_date && (
              <div className="titleMinor">
                <b>date:</b> {new Date(ad.batch.batch_date).toString()}
              </div>
            )}
            {ad.batch.batch_type && (
              <div className="titleMinor">
                <b>batch type: </b> 
                { ad.batch.batch_type === 1 ? "crawl" 
                  : ad.batch.batch_type === 2 ? "dataset" 
                  : ad.batch.batch_type === 3 ? "Custom crawl" 
                  : ad.batch.batch_type === 4 ? "OpenWPM crawl"
                  : "Unknown" }
              </div>
            )}
            {ad.batch.extra_metadata && (
              <div className="titleMinor">
                <b>extra metadata:</b> <pre><code>{JSON.stringify(ad.batch.extra_metadata, null, 4)}</code></pre>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
    </div>
  );
}
